import axios from 'utils/axios';
import { createSlice } from '@reduxjs/toolkit';
import { getFilterDate } from 'utils/formatDateRange';

const initialState = {
  list: {
    isLoading: false,
    error: false,
    data: [],
    count: 0,
  },
  detail: {
    isLoading: true,
    error: false,
    data: {},
    events: [],
    transactions: [],
    consumptionRequests: [],
    linkedAccounts: [],
  },
};

const slice = createSlice({
  name: 'revenueManagementUsers',
  initialState,
  reducers: {
    usersStartLoading(state) {
      state.list.isLoading = true;
      state.list.data = [];
    },

    usersHasError(state, action) {
      state.list.isLoading = false;
      state.list.error = action.payload;
    },

    usersSuccess(state, action) {
      state.list.isLoading = false;
      state.list.data = action.payload.users;
      state.list.count = action.payload.count;
    },

    userByIdStartLoading(state) {
      state.detail.isLoading = true;
      state.detail.data = [];
    },

    userByIdHasError(state, action) {
      state.detail.isLoading = false;
      state.detail.error = action.payload;
    },

    userByIdSuccess(state, action) {
      const { events, user, transactions, consumptionRequests, linkedAccounts } = action.payload;

      state.detail.isLoading = false;
      state.detail.data = user;
      state.detail.events = events;
      state.detail.transactions = transactions;
      state.detail.consumptionRequests = consumptionRequests;
      state.detail.linkedAccounts = linkedAccounts ?? [];
    },
  },
});

export default slice.reducer;

export function getRevenueManagementUsers(appId, page, pageSize, search = []) {
  const updatedSearch = search.map((filter) => {
    if (filter.column === 'creationDate' || filter.column === 'lastSignIn') {
      const { start, end } = getFilterDate(parseInt(filter.additionalValue, 10), filter.value);

      if (filter.operator === '=' || filter.operator === '!=') {
        const newOperator = filter.operator === '=' ? 'between' : 'notBetween';
        return {
          ...filter,
          operator: newOperator,
          value: [start, end],
        };
      }

      return {
        ...filter,
        value: start,
      };
    }

    return { ...filter };
  });

  return async (dispatch) => {
    const searchQuery = updatedSearch.length > 0 ? `&search=${JSON.stringify(updatedSearch)}` : '';
    dispatch(slice.actions.usersStartLoading());
    try {
      const response = await axios.get(
        `/revenue-management/${appId}/users?order=creationDate${searchQuery}&ordering=desc&page=${page}&limit=${pageSize}`,
      );

      dispatch(slice.actions.usersSuccess(response));
    } catch (error) {
      dispatch(slice.actions.usersHasError(error));
    }
  };
}
export function getRevenueManagementUserById(appId, userId) {
  return async (dispatch) => {
    dispatch(slice.actions.userByIdStartLoading());
    try {
      const response = await axios.get(`/revenue-management/${appId}/users/${userId}`);
      dispatch(slice.actions.userByIdSuccess(response));
    } catch (error) {
      dispatch(slice.actions.userByIdHasError(error));
    }
  };
}
